export default __webpack_public_path__ + "img/garage.0c18db5cfa6c2d745e38f605471ad59f.png";